import React, {Component} from "react";
import ApiKeyService from "../../service/ApiKeyService";
import {FormattedDate, FormattedTime} from "react-intl";
import CoreService from "../../service/CoreService";
import {Link} from "react-router";

class ApiKeysPanel extends Component {
    constructor() {
        super();

        this.state = {
            apiKeys: null,
        };
    }

    fetchApiKeys = () => {
        const self = this;

        ApiKeyService.fetchKeys((keys) => {
            const keyRows = [];
            keys.sort((a, b) => a.issued > b.issued ? 1 : -1).forEach((key) => {
                keyRows.push(
                    <tr key={key.tokenId}>
                        <td>{key.obfuscatedToken}</td>
                        <td><FormattedDate
                            value={key.issued}
                            day="numeric"
                            month="numeric"
                            year="numeric"
                        />&nbsp;<FormattedTime
                            value={key.issued}
                            hour12={false}
                        /></td>
                        <td><a href="#"
                               className="small icon icon-trash"
                               onClick={(e) => self.deleteApiKey(e, key.tokenId)}
                        >Delete</a></td>
                    </tr>
                )
            });

            self.setState({apiKeys: keyRows});
        });
    };

    createApiKey = () => {
        const self = this;

        ApiKeyService.createKey((key) => {
            // notify user
            CoreService.showPassiveInfo('Created a new API key.');

            // display modally
            const body = <div>
                <div className="m-b-sm">Here is your new API key. Store this now - it will never be displayed again.</div>
                <div className="m-b-sm"><i className="icon icon-warning m-r-xs"/><strong>Keep this key safe, as it provides access to your account.</strong>
                </div>
                <pre>{key.token}</pre>
            </div>;

            CoreService.showModal('API key', body, {
                onHide() {
                    self.refreshUi();
                }
            });
        })
    };

    /**
     * Delete the file with the given name.
     *
     * @param e {Event}
     * @param tokenId {String}
     */
    deleteApiKey = (e, tokenId) => {
        e.preventDefault();
        const self = this;

        CoreService.showModal('Delete API key', 'Are you sure you want to delete this API key?', {
            hasCloseButton: true,
            closeButtonText: 'Keep',
            hasSaveButton: true,
            saveButtonText: 'Delete',
            onConfirm: () => {
                ApiKeyService.deleteKey(tokenId, () => {
                    // notify user
                    CoreService.showPassiveInfo('Deleted API key.');

                    // refresh UI
                    self.refreshUi();
                });
            }
        });
    };

    refreshUi = () => {
        this.fetchApiKeys();
    };

    componentDidMount = () => {
        this.refreshUi();
    }

    render = () => {
        return <div>
            <div className="row">
                <div className="col-lg-12 m-b-sm">
                    <h3 className="page-subsection">API keys</h3>
                    <p>Create API keys to manage your mocks via <Link to="/docs/mocks/api">our API</Link>.</p>
                    <button className='btn btn-primary m-b-sm' onClick={this.createApiKey}>
                        Create API key
                    </button>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-10 col-md-8 col-lg-8">
                    {/* API Keys */}
                    <div className="panel panel-info">
                        <div className="panel-heading"><h3 className="panel-title">API Keys</h3></div>
                        <div className="panel-body">

                            {this.state.apiKeys === null &&
                                <div className="text-muted">Fetching keys...</div>}

                            {this.state.apiKeys && this.state.apiKeys.length === 0 &&
                                <div className="text-muted">You haven't created any keys.</div>}

                            {this.state.apiKeys && this.state.apiKeys.length > 0 &&
                                <table className="table table-striped">
                                    <thead>
                                    <tr>
                                        <th>Key</th>
                                        <th>Issued</th>
                                        <th>Actions</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.apiKeys}
                                    </tbody>
                                </table>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

export default ApiKeysPanel;



// WEBPACK FOOTER //
// ./src/modules/views/account/ApiKeysPanel.js